import PromptsIcon from '@components/icons/PromptsIcon.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { MenuItemButton } from '../MoreActionsMenu/components/MenuItemButton';

export const LlmCallsMenuButton = () => {
  const { job } = usePageContext();
  const { openModal } = useModalContext();

  if (!job?.llmCalls?.length) {
    return null;
  }

  return (
    <MenuItemButton
      title="View LLM Calls"
      onClick={() => openModal(ModalNamesEnum.AdminLlmCallsModal, { jobId: job.id, llmCalls: job.llmCalls })}
    >
      <PromptsIcon />
      LLM Calls
    </MenuItemButton>
  );
};
